import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { EpisodeTileWall } from './components/EpisodeTileWall';
import { PopularEpisodes } from './components/PopularEpisodes';
import { AboutHost } from './components/AboutHost';
import { SubscribePlatforms } from './components/SubscribePlatforms';
import { GuestHighlights } from './components/GuestHighlights';
import { BeAGuestCTA } from './components/BeAGuestCTA';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-eofa-black text-eofa-white font-body selection:bg-eofa-yellow selection:text-eofa-black" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <EpisodeTileWall data-id="element-4" />
        <PopularEpisodes data-id="element-5" />
        <AboutHost data-id="element-6" />
        <SubscribePlatforms data-id="element-7" />
        <GuestHighlights data-id="element-8" />
        <BeAGuestCTA data-id="element-9" />
        <Newsletter data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}